import { useEffect, useRef, useState } from "react";
// import {GetPurchaseOrderMasterData} from '../store/purchaseOrderAtom';
import { Grid } from "@mui/material";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { GetPriceDataStore } from "../../store/priceListAtom";

function PriceListScroll(props) {
  const priceStoreData = GetPriceDataStore();
  const isMounted = useRef(false);
  const [tableData, setTableData] = useState([]);
  const [checkedAll, setCheckAll] = useState(false);
  const { id } = useParams();

  const navigate = useNavigate();
  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(() => {
    isMounted.current = true;

    if (priceStoreData.coporate_info?.length > 0) {
      setTableData(
        priceStoreData.coporate_info?.map((ele) => {
          return { ...ele, checked: false };
        })
      );
    }

    return () => {
      isMounted.current = false;
    };
  }, [priceStoreData.coporate_info]);

  // const onActionFilterPerform = (action) => {
  //     const option = action.target.value;
  //     if (Number(option) === 0) {
  //         return setTableData(featureList.feature_info);
  //     }
  //     var newList = featureList.feature_info.filter((item) => item.Sales_Order_Status_Id === Number(option));
  //     setTableData(newList);
  // }

  const onCheckAllElement = async (selection) => {
    setCheckAll((prev) => {
      return !prev;
    });

    let newList = tableData?.map((item, i) => {
      return { ...item, checked: !selection };
    });

    await setTableData((prev) => {
      return [...newList];
    });
    // props?.onSelection(newList);
  };

  const onItemSelect = (id) => {
    navigate(
      `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`
    );
  };

  const onCheckboxClick = async (e, index) => {
    let element = tableData[index];
    tableData[index] = { ...element, checked: e.target.checked };
    await setTableData((prev) => {
      return [...tableData];
    });
    props?.onSelection(tableData);
  };

  const managePurchaseStatus = (status) => {
    let defaultClass = "color1";

    switch (status) {
      case "InActive":
        defaultClass = "color2";
        break;
      case "Active":
        defaultClass = "color3";
        break;
      case "Pending for Approval":
        defaultClass = "color4";
        break;
      case "Fulfilled":
        defaultClass = "color5";
        break;
      case "Rejected":
        defaultClass = "color6";
        break;
      case "Confirmed":
        defaultClass = "color1";
        break;
      case "Partially Billed":
        defaultClass = "color8";
        break;

      default:
        break;
    }

    return (
      <span className={`text-sm font-bold md:text-sm ${defaultClass} `}>
        {status}
      </span>
    );
  };

  return (
    <>
      <section className="h-fit max-h-[500px] border border-gray-200 rounded-md p-2 overflow-auto">
        <p className="ml-4 mt-2 font-semibold text-base text-gray-700">All</p>
        {tableData?.map((ele, i) => {
          return (
            <>
              <div
                onClick={() => onItemSelect(ele?.Corporate_Id)}
                key={i}
                className={`px-2 py-1.5 flex items-center mb-2 cursor-pointer ${
                  Number(id) === ele?.Corporate_Id
                    ? "bg-white border-y border-l-4 border-r border-y-gray-200 border-r-gray-200 border-l-blue-600 rounded-sm"
                    : "hover:bg-gray-100 border-y border-l-4 border-r border-y-gray-200 border-r-gray-200 border-l-gray-200 rounded-sm"
                }`}
              >
                <input
                  type="checkbox"
                  checked={Number(id) === ele?.Corporate_Id}
                  className="h-3.5 w-3.5 z-0 border-gray-300 rounded-sm checked:ring-0 focus:ring-0"
                />
                <span className="ml-2 text-xs font-medium">
                  {ele?.Corporate_Short_Code}
                </span>{" "}
                <span className="ml-2 text-xs font-medium">
                  {ele?.Corporate_Status_Name}
                </span>
                <div className="ml-2 text-xs font-medium">
                  {managePurchaseStatus(ele?.Feature_Status_Name)}
                </div>
              </div>
            </>
          );
        })}
      </section>
    </>
  );
}

export default PriceListScroll;
